module.exports = __webpack_public_path__ + "images/般蓝pr长图06-3_02.jpg?v=66df9f15";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图06-3_02.jpg
 ** module id = 175
 ** module chunks = 1 2
 **/